<template>
    <v-footer dark height="auto">
        <v-card flat tile class="white--text text-xs-center" color="#10212B" width="100%">
            <v-card-text>
                <v-layout wrap>
                <v-flex xs12 sm12 md2>
                    <div id="footer_nav">
                        <v-layout row align-center justify-center my-3>
                            <img src="/images/logo.png" width="100">
                        </v-layout>
                        <v-layout row align-center justify-center v-for="(item,i) in pages" :key="i" my-3>
                            <router-link :to="item.link">{{ item.name }}</router-link>
                        </v-layout>
                    </div>
                </v-flex>
                <v-divider vertical></v-divider><br><br>
                <v-flex xs12 sm12 md3>
                    <h3>Newsletter</h3>
                    <v-layout row align-center justify-center>
                        <v-flex xs8>
                            <form @submit.prevent="send_newsletter">
                                <v-text-field
                                        label="Name"
                                        name="form.nama"
                                        v-model="form.nama"
                                        :error-messages="nama_errors"
                                        @blur="$v.form.nama.$touch()"
                                        @input="$v.form.nama.$touch()"
                                        required
                                ></v-text-field>
                                <v-text-field
                                        label="Email"
                                        name="form.email"
                                        v-model="form.email"
                                        :error-messages="email_errors"
                                        @blur="$v.form.email.$touch()"
                                        @input="$v.form.email.$touch()"
                                        required
                                ></v-text-field>
                                <v-text-field
                                        label="Subject"
                                        name="form.subject"
                                        v-model="form.subject"
                                        :error-messages="subject_errors"
                                        @blur="$v.form.subject.$touch()"
                                        @input="$v.form.subject.$touch()"
                                        required
                                ></v-text-field>
                                <v-text-field
                                        label="Message"
                                        name="form.message"
                                        v-model="form.message"
                                        :error-messages="message_errors"
                                        @blur="$v.form.message.$touch()"
                                        @input="$v.form.message.$touch()"
                                        required
                                ></v-text-field>
                                <v-layout row wrap align-center justify-center>
                                    <v-flex xs12 sm12 ma-2>
                                        <v-btn name="simpan" type="submit" block color="primary" class="ma-0">
                                            Submit
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </form>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-divider vertical></v-divider><br><br>
                <v-flex xs12 sm12 md6>
                    <h3>Contact Us</h3>
                    <v-layout row align-center justify-center wrap>
                        <v-flex xs12 sm12 md5 ma-2>
                            <br>
                            <br>
                            <iframe width="100%" id="gmap_canvas" src="https://maps.google.com/maps?q=bandung%20champion%20city&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0">
                            </iframe>
                        </v-flex>
                        <v-flex xs12 sm12 md5 ma-2>
                            <table border="0" style="text-align: left;" cellpadding="10" cellspacing="10">
                                <tr>
                                    <td><img src="/images/telephone.png" width="20"></td>
                                    <td>(021) 3002 0929</td>
                                </tr>
                                <tr>
                                    <td><img src="/images/amplop.png" width="20"></td>
                                    <td>marketing.bcc@championcity.co.id</td>
                                </tr>
                                <tr>
                                    <td><img src="/images/place.png" width="20"></td>
                                    <td>
                                        Lucky Square Mall Lt 5 (P8)<br>
                                        Jl.Terusan Jakarta No. 2<br>
                                        Bandung Jawa Barat 40281<br>
                                    </td>
                                </tr>
                            </table>
                        </v-flex>
                    </v-layout>
                </v-flex>
                </v-layout>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-text class="white--text">
                &copy; 2019 Bandung Champion City.  All Rights Reserved
            </v-card-text>
        </v-card>
    </v-footer>
</template>

<style scoped>
    #footer_nav a {
        text-decoration: none;
        text-transform: uppercase;
    }
</style>

<script>
    import HomeAPI from "@/api/home";
    import {validationMixin} from 'vuelidate';
    import {required} from 'vuelidate/lib/validators';
    import swal from "sweetalert2";

    export default {
        mixins: [validationMixin],

        validations: {
            // validations
            form: {
                nama: {required},
                subject: {required},
                email: {required},
                message: {required},
            },
        },

        data: () => ({
            // data
            form: {
                nama: null,
                subject: null,
                email: null,
                message: null,
            },
            pages: [
                { name: "Home", link: "/" },
                { name: "About", link: "/about" },
                { name: "Wahana", link: "/wahana" },
                { name: "Ticketing", link: "/ticketing" },
                // { name: "Activities", link: "/activities" },
                // { name: "Raport", link: "/raport" },
                // { name: "CCTV", link: "/cctv" },
            ]
        }),
        computed: {
            // computed
            nama_errors() {
                const errors = [];
                if (!this.$v.form.nama.$dirty) return errors;
                !this.$v.form.nama.required && errors.push('Nama harus diisi.');
                return errors;
            },

            subject_errors() {
                const errors = [];
                if (!this.$v.form.subject.$dirty) return errors;
                !this.$v.form.subject.required && errors.push('Subject harus diisi.');
                return errors;
            },

            email_errors() {
                const errors = [];
                if (!this.$v.form.email.$dirty) return errors;
                !this.$v.form.email.required && errors.push('Email harus diisi.');
                return errors;
            },

            message_errors() {
                const errors = [];
                if (!this.$v.form.message.$dirty) return errors;
                !this.$v.form.message.required && errors.push('Message harus diisi.');
                return errors;
            },
        },

        methods: {
            async send_newsletter() {
                this.$v.form.$touch();
                if (!this.$v.form.$invalid) {
                    this.$store.dispatch("loading/start");
                    HomeAPI.postNewsletter(this.form).then(response => {
                        this.$store.dispatch("loading/stop");
                        swal.fire({
                            type: 'info',
                            title: response.data.results.message,
                            reverseButtons: false,
                            confirmButtonText: 'ok',
                        });

                        this.form = {
                            nama: null,
                            subject: null,
                            email: null,
                            message: null
                        };
                    }).catch(error => {
                        this.$store.dispatch("loading/stop");
                    });
                }
            }
        },
    }
</script>
